// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__Checkbox from "../../components/html/Checkbox.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ClientConsentForm(Props) {
  let payload = Props.payload;
  const match = React.useState(function () {
        
      });
  const setToast = match[1];
  const match$1 = React.useState(function () {
        return /* [] */0;
      });
  const setScopes = match$1[1];
  const scopes = match$1[0];
  let tmp;
  let exit = 0;
  if (payload !== undefined && !(typeof payload === "string" || payload.NAME !== "ClientConsentPayload")) {
    const payload$1 = payload.VAL;
    const __x = payload$1.requested_scope;
    tmp = JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
          onSubmit: (function (param) {
              
            }),
          action: "/client/consent",
          method_: "POST",
          className: "mt-8",
          children: [
            JsxRuntime.jsx("input", {
                  name: "_csrf",
                  type: "hidden",
                  value: payload$1.csrfToken
                }),
            JsxRuntime.jsx("input", {
                  name: "challenge",
                  type: "hidden",
                  value: payload$1.challenge
                }),
            JsxRuntime.jsx("div", {
                  children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, scope) {
                              const Key = "scope-" + String(index);
                              return JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                          isChecked: Belt__Belt_List.has(scopes, scope, (function (a, b) {
                                                  return a === b;
                                                })),
                                          onChange: (function (param) {
                                              Curry._1(setScopes, (function (param) {
                                                      if (Belt__Belt_List.has(scopes, scope, (function (a, b) {
                                                                return a === b;
                                                              }))) {
                                                        return Belt__Belt_List.keep(scopes, (function (s) {
                                                                      return s !== scope;
                                                                    }));
                                                      } else {
                                                        return {
                                                                hd: scope,
                                                                tl: scopes
                                                              };
                                                      }
                                                    }));
                                            }),
                                          text: scope,
                                          value: scope,
                                          name: "grant_scope"
                                        }, Key);
                            }))),
                  className: "flex flex-col space-y-4"
                }),
            JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                  kind: "primary",
                  name: "submit",
                  value: "allow",
                  type_: "submit",
                  className: "mt-6",
                  isWide: true,
                  children: "Разрешить"
                }),
            JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                  kind: "default",
                  name: "submit",
                  value: "deny",
                  type_: "submit",
                  className: "mt-4",
                  isWide: true,
                  children: "Отклонить"
                })
          ]
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: "No csrf token provided"
        });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
              toast: match[0],
              onExpired: (function (param) {
                  Curry._1(setToast, (function (param) {
                          
                        }));
                }),
              children: JsxRuntime.jsxs(Buhta_cabinet__Box.make, {
                    title: "Доступ",
                    className: "relative",
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "text-gray-medium",
                            children: "Стороннее приложение запрашивает доступ на:"
                          }),
                      tmp
                    ]
                  })
            });
}

const make = ClientConsentForm;

export {
  make ,
}
/* Buhta_cabinet__Box Not a pure module */
